export default __webpack_public_path__ + "static/grouping-do-914851e42d5a8474e19a9ccdd02dfefd.png";